export default function Loading({ label = 'Caricamento…', compact = false }) {
  if (compact) {
    return <div className="text-sm text-gray-500">{label}</div>
  }
  return <div className="p-8 text-center text-gray-500">{label}</div>
}
